import {PanelsTopLeftIcon} from 'lucide-react';
import {Button, DialogFooter} from '@tinct/web-components';

export type PaywallFooterProps = {
  /** Set for a reason no self-serve plan covers: the only action is talking to sales. */
  salesUrl?: string;
  isNotEnoughLivePages: boolean;
  remainingQuota: number;
  isCheckoutPending: boolean;
  onClose: () => void;
  onPublishPartial: () => void;
  onUpgrade: () => void;
};

export function PaywallFooter({
  salesUrl,
  isNotEnoughLivePages,
  remainingQuota,
  isCheckoutPending,
  onClose,
  onPublishPartial,
  onUpgrade,
}: PaywallFooterProps) {
  return (
    <DialogFooter className="flex-row items-center justify-between sm:justify-between">
      <Button variant="ghost" onClick={onClose}>
        Cancel
      </Button>
      <div className="flex items-center gap-2">
        {salesUrl ? (
          <Button asChild>
            <a href={salesUrl} target="_blank" rel="noreferrer">
              Talk to sales
            </a>
          </Button>
        ) : (
          <>
            {isNotEnoughLivePages && (
              <Button variant="outline" onClick={onPublishPartial}>
                <PanelsTopLeftIcon className="size-4" />
                Publish top {remainingQuota} pages
              </Button>
            )}
            <Button onClick={onUpgrade} disabled={isCheckoutPending}>
              {isCheckoutPending ? 'Redirecting...' : isNotEnoughLivePages ? 'Upgrade to publish all' : 'Upgrade'}
            </Button>
          </>
        )}
      </div>
    </DialogFooter>
  );
}
